import { Autocomplete, FormHelperText, Grid2, TextField } from "@mui/material";
import type { Moment } from "moment-timezone";
import {
	EndFilter,
	StartFilter,
} from "@/pages/delays/shared/components/StartEndFilter";

const CREW_OPTIONS = ["A", "B", "C", "D"] as const;
const SHIFT_OPTIONS = ["D", "N"] as const;
const MAX_CREWS = 3;

type Props = {
	startDate: Moment;
	endDate: Moment;
	crews: string[];
	shift: string | null;
	dateError?: string;
	onStartDateChange: (date: Moment | null) => void;
	onEndDateChange: (date: Moment | null) => void;
	onCrewsChange: (crews: string[]) => void;
	onShiftChange: (shift: string | null) => void;
};

export const ManagerFilters = ({
	startDate,
	endDate,
	crews,
	shift,
	dateError,
	onStartDateChange,
	onEndDateChange,
	onCrewsChange,
	onShiftChange,
}: Props) => {
	return (
		<Grid2 container spacing={1} alignItems="center">
			<Grid2 size={{ xs: 12, md: 1.5 }} sx={{ minWidth: 160 }}>
				<StartFilter
					value={startDate}
					onChange={(date) => date && onStartDateChange(date)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }} sx={{ minWidth: 160 }}>
				<EndFilter
					value={endDate}
					onChange={(date) => date && onEndDateChange(date)}
				/>
				{dateError && <FormHelperText error>{dateError}</FormHelperText>}
			</Grid2>
			<Grid2 size={{ xs: 6, md: 1.5 }}>
				<Autocomplete
					multiple
					disableCloseOnSelect
					size="small"
					options={[...CREW_OPTIONS]}
					value={crews}
					onChange={(_event, value) => onCrewsChange(value)}
					getOptionDisabled={() => crews.length >= MAX_CREWS}
					ChipProps={{
						size: "small",
						sx: {
							height: 20,
							fontSize: "0.75rem",
							"& .MuiChip-deleteIcon": { fontSize: "0.875rem" },
						},
					}}
					sx={{
						"& .MuiAutocomplete-inputRoot": {
							flexWrap: "nowrap",
						},
						"& .MuiAutocomplete-input": {
							minWidth: "20px !important",
							width: 0,
						},
					}}
					renderInput={(params) => (
						<TextField {...params} label="Crew" size="small" />
					)}
					data-test-id="crew-filter"
				/>
			</Grid2>
			<Grid2 size={{ xs: 6, md: 0.75 }}>
				<Autocomplete
					options={[...SHIFT_OPTIONS]}
					value={shift}
					onChange={(_event, value) => onShiftChange(value)}
					renderInput={(params) => (
						<TextField {...params} label="Shift" size="small" />
					)}
					data-test-id="shift-filter"
				/>
			</Grid2>
		</Grid2>
	);
};
